import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformPrototyperPermissions } from './prototyper-permissions.transformers';
import type { PrototyperPermissionsCollection } from './prototyper-permissions.types';

export function prototyperPermissionsReducer(
  state: CollectionStateSlice<PrototyperPermissionsCollection> = {},
  action: CollectionActions<PrototyperPermissionsCollection>,
): CollectionStateSlice<PrototyperPermissionsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'prototyperPermissions') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<PrototyperPermissionsCollection>(
          state,
          transformIntoDocuments(
            result.permissions,
            transformPrototyperPermissions,
          ),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'prototyperPermissions') {
        const { result, ref } = action.payload;

        return mergeWebsocketDocuments<PrototyperPermissionsCollection>(
          state,
          transformIntoDocuments(
            result.permissions,
            transformPrototyperPermissions,
          ),
          ref,
        );
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'prototyperPermissions') {
        const { result, ref, originalDocument } = action.payload;

        // Remove the old PrototyperPermission document
        const stateWithoutOldDocument =
          removeDocumentById<PrototyperPermissionsCollection>(
            ref,
            state,
            originalDocument.id,
          );

        // Add the new document with updated data
        return mergeWebsocketDocuments<PrototyperPermissionsCollection>(
          stateWithoutOldDocument,
          transformIntoDocuments(
            result.permissions,
            transformPrototyperPermissions,
          ),
          ref,
        );
      }
      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'prototyperPermissions') {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById<PrototyperPermissionsCollection>(
          ref,
          state,
          originalDocument.id,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
